module.exports = __webpack_public_path__ + "static/img/gaozhongdili.ada78abe.jpg";